export const codeToArray = (code) => { var _a; return (_a = code === null || code === void 0 ? void 0 : code.split("")) !== null && _a !== void 0 ? _a : []; };
export default { codeToArray };
//# sourceMappingURL=codeToArray.js.map